module.exports = __webpack_public_path__ + "static/img/zt@2x.3802a27d.png";